import { toJS } from "mobx";
import { useObserver } from "mobx-react";
import React, { useContext, useState } from "react";
import { Store } from "../state/state";
import TextField from "./TextField";

function Height_Width({ height, width, onChange }) {
  const store = useContext(Store);
  const [link, setLink] = useState(0);

  return useObserver(() => (
    <div className="flex items-center w-full my-2">
      <div className="flex-1">
        <TextField
          label="العرض"
          value={store.theme.images[store.select].width}
          onChangeText={(width) => {
            const original = {
              height: store.theme.images[store.select].height,
              width: store.theme.images[store.select].width,
            };
            store.theme.images[store.select].width = width;

            if (link) {
              let newResult = Math.round(
                width * (original.width / original.height)
              );
              console.log({ original, newResult });
              if (newResult)
                store.theme.images[store.select].height = newResult;
            }
          }}
        />
        <TextField
          label="الطول"
          value={store.theme.images[store.select].height}
          onChangeText={(height) => {
            ///adjusted height = <user-chosen width> * original height / original width
            const original = {
              height: store.theme.images[store.select].height,
              width: store.theme.images[store.select].width,
            };
            store.theme.images[store.select].height = height;
            if (link) {
              let newResult = Math.round(
                height * (original.height / original.width)
              );
              console.log({ original, newResult });

              store.theme.images[store.select].width =
                height * (original.height / original.width);
            }
          }}
        />
      </div>
      <div
        className=" mx-5 hover:bg-gray-400 p-2 shadow-lg   rounded-md border  cursor-pointer"
        onClick={() => {
          setLink(!link);
        }}
        style={{ backgroundColor: "#dcdcdc" }}
      >
        <span className={`fa fa-${link ? "un" : ""}link `}></span>
      </div>
    </div>
  ));
}

export default Height_Width;
